import React from "react";
import { useTranslation } from "react-i18next";

const STEPS = [
  { num: "home.steps.step1.num", title: "home.steps.step1.title", desc: "home.steps.step1.desc" },
  { num: "home.steps.step2.num", title: "home.steps.step2.title", desc: "home.steps.step2.desc" },
  { num: "home.steps.step3.num", title: "home.steps.step3.title", desc: "home.steps.step3.desc" },
];

function GetStarted() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      {/* Header */}
      <div className="glcontainer mb-[40px] xl:mb-[60px]">
        <div className="flex flex-col xl:flex-row xl:gap-[206px] gap-[20px] xl:items-start">
          <h2 className="font-48-28 xl:max-w-[517px]">{t("home.steps.title")}</h2>
          <p className="font-18-14 xl:max-w-[497px] xl:text-right">{t("home.steps.desc")}</p>
        </div>
      </div>

      {/* Step rows – full width */}
      <div className="flex flex-col w-full">
        {STEPS.map((step, i) => (
          <div key={i} className="bg-[#f7f7f7] border-b border-[rgba(0,0,0,0.1)]">
            <div className="glcontainer flex flex-col xl:flex-row xl:items-center gap-[12px] xl:gap-[80px] py-[26px] xl:py-[40px]">
              <div className="flex items-center gap-[20px] xl:gap-[80px]">
                <span className="font-['Montserrat'] font-normal text-[20px] xl:text-[32px] text-[#707070] leading-[1.4] w-[36px] xl:w-[44px] shrink-0">
                  {t(step.num)}
                </span>
                <h3 className="font-36-20">{t(step.title)}</h3>
              </div>
              <p className="font-16-14 xl:max-w-[460px] xl:ml-auto pl-[56px] xl:pl-0">{t(step.desc)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default GetStarted;
